import { SupervisorKpiGrid } from "@/components/supervisor/SupervisorKpiGrid";
import { SupervisorAttentionQueue } from "@/components/supervisor/SupervisorAttentionQueue";
import { SupervisorManagerTable } from "@/components/supervisor/SupervisorManagerTable";
import type { SupervisorSummary } from "@/api/types";

/**
 * S2 — Supervisor Home (D-067). Tier-gated team control surface rendered at /today
 * ONLY when the backend returns a supervisorSummary (supervisor tier). The gate in
 * HomeQueuePage falls back to the personal home for manager/admin/director (no
 * payload) — AC-SH-KPI-008 / AC-SH-SCOPE-003 (Director = separate S5 surface).
 * 3 blocks on the S1 payload; DS bound to live globals.css; mockup v2.
 */
export function SupervisorHome({ summary }: { summary: SupervisorSummary }) {
  return (
    <div className="p-4 md:p-6">
      <div className="mx-auto w-full max-w-[1320px] space-y-6">
        <header>
          <h1 className="text-xl font-semibold tracking-tight">Контроль команди</h1>
          <p className="text-sm text-muted-foreground">
            Що в команді · де втрутитись. Scope = ваша команда.
          </p>
        </header>

        <section>
          <SupervisorKpiGrid kpis={summary.kpis} />
        </section>

        <section>
          <h2 className="mb-2 text-sm font-semibold text-muted-foreground">Потребує уваги</h2>
          <SupervisorAttentionQueue queue={summary.attentionQueue} />
        </section>

        <section>
          <h2 className="mb-2 text-sm font-semibold text-muted-foreground">Менеджери команди</h2>
          <SupervisorManagerTable rows={summary.managerTable} />
        </section>
      </div>
    </div>
  );
}

export function SupervisorHomeSkeleton() {
  return (
    <div className="p-4 md:p-6">
      <div className="mx-auto w-full max-w-[1320px] space-y-6">
        <div className="h-12 w-64 animate-pulse rounded bg-muted" />
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-24 animate-pulse rounded-xl bg-muted" />
          ))}
        </div>
        <div className="h-48 animate-pulse rounded-2xl bg-muted" />
        <div className="h-64 animate-pulse rounded-2xl bg-muted" />
      </div>
    </div>
  );
}
